import { FormStatus } from '../../forms/models/forms.model';
import { DocumentTypesEnum } from './document-types.enum';

export enum ViewType {
  List = 1,
  Thumbnails,
}

export interface Form {
  chartNoteId: number;
  formioKey: string;
  formioTemplateVersion?: number;
  formName: string;
  createdBy: string;
  practitioner: string;
  statusId: FormStatus;
  chartNoteDate: Date;
  thumbnailUrl: string;
  pdfUri: string;
  isViewEnabled: boolean;
  isEditEnabled: boolean;
  isESignEnabled: boolean;
  requiresESign?: boolean;
  thumbnailLoaded: boolean;
  statusLabel: string;
  clientCaseId: number;
  documentTypeId: DocumentTypesEnum;
  isSignOffAfterClientCompletion: boolean;
  isSigned: boolean;
}

export function newForm(form?: Partial<Form>): Form {
  return {
    chartNoteId: 0,
    formioKey: '',
    formioTemplateVersion: undefined,
    formName: '',
    createdBy: '',
    practitioner: '',
    statusId: FormStatus.noStatus,
    chartNoteDate: new Date(),
    thumbnailUrl: '',
    pdfUri: '',
    isViewEnabled: false,
    isEditEnabled: false,
    isESignEnabled: false,
    requiresESign: undefined,
    thumbnailLoaded: false,
    statusLabel: '',
    clientCaseId: 0,
    documentTypeId: DocumentTypesEnum.Unknown,
    isSignOffAfterClientCompletion: false,
    isSigned: false,
    ...form,
  };
}
